<template>
  <div class="list">
    <!-- header-title -->
    <div class="header-title flex-row flex__between margin-bottom-10">
      <div class="leftSection flex-row flex__left">
        <div class="theTitle theTitle__lv5 flex-row flex__center">STT</div>
        <div class="theTitle theTitle__lv1 flex-row flex__left padding-left-10">
          Tiêu đề
        </div>
      </div>
      <div class="rightSection flex-row flex__right">
        <div
          class="theTitle theTitle__lv2 flex-row flex__right margin-right-10"
        >
          Trạng thái
        </div>
        <div
          class="theTitle theTitle__lv3 flex-row flex__right padding-right-10"
          @click="sortByCreateTime"
        >
          Ngày tạo
          <sort-caret
            :order="currentCreateTimeOrder"
            :sort="currentSortBy"
            :field="'createTime'"
          />
        </div>
      </div>
    </div>
    <!-- list-docs -->
    <VuePerfectScrollbar
      class="scroll-area"
      :settings="perfectScrollbarSetting"
      infinite-wrapper
    >
      <div class="list-docs">
        <div
          v-for="(item, $itemIndex) in this.data"
          v-bind:key="$itemIndex"
          class="item flex-row flex__between"
        >
          <div
            class="leftSection flex-row flex__left clickable"
            @click="viewDetail(item)"
          >
            <div class="theTitle__lv5">
              <div class="flex-row flex__center">
                <div class="section-check flex-row flex__center">
                  {{ $itemIndex + 1 }}
                </div>
                <img
                  class="icon-small"
                  src="../../../assets/img/symbol/doc.svg"
                  alt
                />
              </div>
            </div>
            <div class="theTitle__lv1 margin-right-10">
              <div class="title-docs flex-col flex__left">
                <div class="tt_1 clickable">{{ item.caseTitle }}</div>
                <div class="tt_2 flex-row flex__left margin-top-10">
                  <span>{{ item.requestDeptName }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="rightSection flex-row flex__right">
            <div
              class="
                theTitle__lv2
                flex-row flex__right
                padding-left-10
                font-size__small
              "
            >
              <div class="flex-row flex__right">
                <el-tag
                  v-if="item.status === 'DANGXULY'"
                  size="mini"
                  :class="['priority', 'lv2']"
                  >{{ item.state }}</el-tag
                >
                <el-tag
                  v-if="item.status === 'HOANTHANH'"
                  size="mini"
                  :class="['priority', 'lv4']"
                  >{{ item.state }}</el-tag
                >
                <el-tag
                  v-if="item.status === 'HUY'"
                  size="mini"
                  :class="['priority', 'lv1']"
                  >{{ item.state }}</el-tag
                >
              </div>
            </div>
            <div
              class="
                theTitle__lv3
                flex-row flex__right
                padding-right-10
                font-size__small
              "
            >
              <div class="flex-row flex__right">
                <span>{{
                  item.createTime | dateFormatter({ nullValue: "-" })
                }}</span
                >&nbsp;&nbsp;
                <div
                  :class="[
                    'theDueDate',
                    item.status === 'DANGXULY'
                      ? 'lv2'
                      : item.status === 'HOANTHANH'
                      ? 'lv3'
                      : item.status === 'HUY'
                      ? 'lv1'
                      : '',
                  ]"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <infinite-loading
          ref="infiniteLoading"
          spinner="spiral"
          @infinite="infiniteHandler"
        >
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
        <div class="flex-row flex__center" v-if="this.data.length === 0">
          Không có dữ liệu
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import dateFormatter from "../../../filters/dateFormatter";
import SortCaret from "../../doc-out/SortCaret";

export default {
  name: "dangxulyMainContent",
  props: ["data"],
  components: {
    VuePerfectScrollbar,
    SortCaret,
    InfiniteLoading,
  },
  filters: { dateFormatter },
  methods: {
    sortByCreateTime() {
      this.currentCreateTimeOrder =
        this.currentCreateTimeOrder == "desc" ? "asc" : "desc";
      this.currentSortBy = "createTime";
      this.$emit("sortByCreateTime", {
        sortBy: this.currentSortBy,
        sortOrder: this.currentCreateTimeOrder,
      });
    },

    viewDetail(item) {
      this.$emit("viewDetail", {
        caseMasterId: item.caseMasterId,
      });
    },
    infiniteHandler($state) {
      this.$emit("infiniteHandler", $state);
    },
  },
  data() {
    return {
      currentSortBy: "createTime",
      currentCreateTimeOrder: "desc",
      currentUpdateTimeOrder: "desc",
    };
  },
  watch: {
    data(newValue) {
      if (newValue !== this.data) {
        this.data = newValue;
      }
    },
  },
};
</script>

<style scoped>
.checkBtn {
  height: 100px;
  width: 100px;
}
.list {
  /* height: calc(100% - 50px - 15px) !important; */
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/components/dangxulyMainContent.vue